import type { ContactConflictGroup } from "../dtos/contact-conflicts";

export const isContactConflictUid = (
  value: string | null | undefined,
): value is string =>
  !!value &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);

export function contactConflictLeadPath(nanoId: string | null): string | null {
  return nanoId && /^\d+-[a-zA-Z0-9]{4}$/.test(nanoId)
    ? `/leads-new/${nanoId}`
    : null;
}

export function contactConflictDestination(path?: string): string {
  return path && /^\/leads-new\/\d+-[a-zA-Z0-9]{4}$/.test(path)
    ? path
    : "/leads";
}

/** Every duplicate category needs an explicit choice from the current preview. */
export function selectedConflictWinners(
  groups: ContactConflictGroup[],
  selections: Record<string, string>,
): string[] | null {
  const winners: string[] = [];
  for (const group of groups.filter((item) => item.requiresChoice)) {
    const winner = group.leads.find(
      (lead) => lead.journeyUId && lead.journeyUId === selections[group.key],
    );
    if (!winner?.journeyUId) return null;
    winners.push(winner.journeyUId);
  }
  return winners;
}

export function contactConflictError(error: unknown): {
  stale: boolean;
  message: string;
} {
  const response = (
    error as { response?: { status?: number; data?: { code?: string } } }
  )?.response;
  if (response?.data?.code === "CONTACT_CONFLICT_STALE")
    return {
      stale: true,
      message:
        "The leads or pending request changed. Review the refreshed details and choose again.",
    };
  if (response?.status === 403)
    return {
      stale: false,
      message: "You do not have permission to resolve this contact conflict.",
    };
  if (response?.status === 404)
    return {
      stale: false,
      message: "This contact conflict is no longer available.",
    };
  if (response?.status === 409)
    return {
      stale: true,
      message:
        "This conflict cannot be resolved with the current details. Review the latest leads before trying again.",
    };
  return {
    stale: false,
    message: "Could not load or resolve this conflict. Please try again.",
  };
}
